// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'phone-stethescope';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M4.742 4.428H2.055a.962.962 0 0 0-.962.962v10.583c0 .532.43.962.962.962h7.697c.532 0 .962-.43.962-.962v-3.54M5.182 14.3h1.444m4.182-13.11h.667a.667.667 0 0 1 .666.666v2.666a2.666 2.666 0 0 1-5.332 0V1.856a.667.667 0 0 1 .667-.666h.666m7.332 4.665a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666z' />
    <path d='M9.475 7.188v.334a3 3 0 0 0 5.999 0V5.855' />
  </g>
);

export const viewBox = '0 0 18 18';
